export default __webpack_public_path__ + "static/media/group-pictures-border.89e7ee66.svg";